import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "../../../../Network/API";
import Select from 'react-select'
import isTenantUser from "../../../../CustomHook/tenantUser";
export default function FilterSiteRmsAlarm({callbackSearch}){
  const tenants = useSelector((state) => state.tenantReducer)
  const select_rms_alarm_master = useSelector((state) => state.rmsAlarmHistoryReducer)
  const { user: profileUser } = useSelector((state) => state.profileReducer);
  const { user: authUser } = useSelector((state) => state.authReducer);
  const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
  
  const [resetKey, setResetKey] = useState(0);
  const modalRef1 = useRef()
  const [alarm_type_id, setAlarmId] = useState('');
  const array_data = {
    'page': 1,
    'site_code': "",
    'tenant_id': "",
    'cluster': "",
    'zone': "",
    'alarm_type': "",
    'start_date': "",
    'end_date': "",
    'filter_type': "",
    'query': "",
    'loadMore': false,
  }


  const searchAlarmType = (e) => {

    if (!e) {
            setAlarmId('');
            return;
        }

        // For multi-select, you might want to extract values differently
        const selectedValues = e.map(item => item.value).join(',');
     //   console.log("Selected Alarm Types:", selectedValues);
        setAlarmId(selectedValues);

    // if (!e) {
    //   setAlarmId('');
    //   return;
    // }
     
    // setAlarmId(e?.value)
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    array_data.query = alarm_type_id;
    array_data.filter_type = event.target.filter_type.value;
    array_data.tenant_id = event.target.tenant.value;
    array_data.start_date = event.target.from_date.value;
    array_data.end_date = event.target.to_date.value;
    array_data.page = 1;
    callbackSearch(array_data)
  }

  const resetForm=()=>{

    array_data.query = '';
    array_data.filter_type = '';
    array_data.tenant_id = '';
    array_data.start_date = '';
    array_data.end_date = '';
    array_data.page = 1;

    callbackSearch(array_data)
  }


  return (
    <>
      <div className="dropdown d-inline-block">
        <button className="btn btn-info rounded-0 text-white"
          type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa-solid fa-filter"></i> Quick Filter
        </button>

        <div className="dropdown-menu p-2 shadow" aria-labelledby="dropdownMenuButton2" onClick={(e) => e.stopPropagation()}>
          <div style={{ width: '400px' }}>

            <h5 className='border-bottom pb-2 fw-bold mb-2'>Quick Filter</h5>
            <form ref={modalRef1} onSubmit={handleSubmit} id="add_country_form">

            {/* //alarm time asc/desc */}

            <div className='row'>
       


              {!tenantUser && (
              <div className="form-group mb-2 col-md-6">
                <label className="form-label fs-7">Tenant</label>
                <select name="tenant" className='form-select form-select-sm'>
                  <option value={``}>All Tenant</option>
                  {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                    <option value={tenant.id}>{tenant.name}</option>
                  ))}
                </select>
              </div>
              )}
              {tenantUser && <input type="hidden" name="tenant" value="" />}

              <div className="form-group mb-2 col-md-6">
                <label className="form-label fs-7">Alarm Name</label>
                <Select key={resetKey} onChange={searchAlarmType} name="alarm_type" isClearable closeMenuOnSelect={true} options={select_rms_alarm_master?.alarm_master} isMulti />

              </div>
            </div>
            <div className="form-group mb-2 d-none">
              <label className="form-label fs-7">Filter Types</label>
              <select name="filter_type" className='form-select form-select-sm'>
                <option value={``}>All</option>
                <option value={`1`}>Active Alarms</option>
                <option value={`2`}>Long Duration Active Alarms</option>
                <option value={`3`}>Abnormal Alarms</option>
                <option value={`4`}>Unusual Alarm Types</option>
                <option value={`5`}>Critical Alarms Only</option>
                <option value={`6`}>Recently Closed Alarms</option>
                <option value={`7`}>Off-Hour Alarms</option>
                <option value={`8`}>High Alarm Density</option>
                {/* <option value={`8`}>Top Frequent Alarms</option> */}
              </select>
            </div>
            <div className="form-group mb-2">
              <label className="form-label fs-7">Date</label>
              <div className="input-group input-group-sm">
                <input name="from_date" type="date" class="form-control" placeholder="" />
                <input name="to_date" type="date" class="form-control" placeholder="" />
              </div>

            </div>


            <div className="card-footer mt-2 mb-2">
<button type="submit" className="btn btn-success btn-sm me-2">Apply Filter</button>
            <button onClick={()=>resetForm()} type="button" className="btn btn-danger btn-sm">Reset Filter</button>
            </div>
</form>
          </div>



        </div>
      </div>
    </>
  )

}